import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=88a26722&scoped=true"
import script from "./Reason.vue?vue&type=script&lang=js"
export * from "./Reason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a26722",
  null
  
)

export default component.exports